import React, { useEffect, useState } from 'react';
import { useIsMobile } from '../hooks/use-mobile';
import { Search } from 'lucide-react';

const SearchForm = ({ filters, onChange, onSearch }) => {
  const isMobile = useIsMobile();
  const [localFilters, setLocalFilters] = useState(filters);
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);

  useEffect(() => {
    setLocalFilters(filters);
  }, [filters]);

  // Fetch brands once on mount
  useEffect(() => {
    fetch('https://panel.bustosautomobile.ch/api/getBrands')
      .then((res) => res.json())
      .then((data) => {
        setBrands(Array.isArray(data) ? data : []);
      })
      .catch(() => setBrands([]));
  }, []);

  // Fetch models when brand changes
useEffect(() => {
  if (!localFilters.brand) {
    setModels([]);
    return;
  }

  fetch(`https://panel.bustosautomobile.ch/api/getModels?brand=${localFilters.brand}`)
    .then((res) => res.json())
    .then((data) => {
      setModels(Array.isArray(data) ? data : []);
    })
    .catch(() => setModels([]));
}, [localFilters.brand]);


  const defaultFilters = { brand: '', model: '', type: '', price: '' };

  const handleChange = (key) => (e) => {
    const newFilters = { ...localFilters, [key]: e.target.value };
    setLocalFilters(newFilters);
    onChange(newFilters);
    onSearch();
  };

  const handleClear = () => {
    setLocalFilters(defaultFilters);
    onChange(defaultFilters);
    onSearch();
  };

  const capitalizeFirst = (str) => {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const formContent = (
    <>
      {/* Brand select */}
      <select
        value={localFilters.brand}
        onChange={handleChange('brand')}
        className="bg-transparent text-white border-none focus:outline-none text-sm w-full md:w-[30%] p-1"
      >
        <option value="" className="text-black">
          Marke
        </option>
        {brands.map((brand) => (
          <option className="text-black" key={brand} value={brand}>
            {capitalizeFirst(brand)}
          </option>
        ))}
      </select>

      {/* Model select */}
      {/* <select
        value={localFilters.model}
        onChange={handleChange('model')}
        className="bg-transparent text-white border-none focus:outline-none text-sm w-full md:w-[30%] p-1"
      >
        <option value="" className="text-black">
          Modell
        </option>
        {models.map((model) => (
          <option className="text-black" key={model} value={model}>
            {capitalizeFirst(model)}
          </option>
        ))}
      </select> */}

      {/* Fuel type */}
      <select
        value={localFilters.type}
        onChange={handleChange('type')}
        className="bg-transparent text-white border-none focus:outline-none text-sm w-full md:w-[50%] p-1"
      >
        <option className="text-black" value="">
          Zeige alle Autos
        </option>
        <option className="text-black" value="Elektro">
          Elektro
        </option>
        <option className="text-black" value="diesel">
          Diesel
        </option>
        <option className="text-black" value="petrol">
          Benzin
        </option>
        <option className="text-black" value="Mild-Hybrid Benzin/Elektro">
          Mild-Hybrid Benzin/Elektro
        </option>
        <option className="text-black" value="Mild-Hybrid Diesel/Elektro">
          Mild-Hybrid Diesel/Elektro
        </option>
        <option className="text-black" value="Plug-in hybrid Benzin/Elektro">
          Plug-in hybrid Benzin/Elektro
        </option>
      </select>

      {/* Price */}
      <select
        value={localFilters.price}
        onChange={handleChange('price')}
        className="bg-transparent text-white border-none focus:outline-none text-sm w-full md:w-[30%] p-1"
      >
        <option className="text-black" value="">
          Preise
        </option>
        {Array.from({ length: 20 }).map((_, i) => {
          const min = i * 10000;
          const max = min + 10000;
          return (
            <option className="text-black" key={i} value={`${min}-${max}`}>
              {`${min.toLocaleString()} - ${max.toLocaleString()}`}
            </option>
          );
        })}
      </select>
    </>
  );

  if (isMobile) {
    return (
      <form
        onSubmit={(e) => e.preventDefault()}
        className="flex flex-col w-full md:max-w-[250px] mx-auto gap-2 bg-black rounded-2xl p-4"
      >
        <div className="flex flex-col gap-2 w-full">{formContent}</div>
        <button
          type="submit"
          className="mt-2 bg-[#0048AE] rounded-full flex items-center justify-center text-white w-full h-10"
        >
          Suchen
          <Search className="ml-2 h-4 w-4" />
        </button>
        <button
          type="button"
          onClick={handleClear}
          className="mt-2 bg-[#0048AE] rounded-full flex items-center justify-center text-white w-full h-10"
        >
          Filter zurücksetzen
        </button>
      </form>
    );
  }

  return (
    <div className="flex justify-center mb-10">
      <form
        onSubmit={(e) => e.preventDefault()}
        className="w-full max-w-4xl bg-[#020202] rounded-[80px] border border-[#424242] px-6 py-4 flex flex-wrap md:flex-nowrap gap-2 items-center relative"
      >
        {formContent}
        <button
          type="submit"
          className="ms-2 mt-2 bg-[#0048AE] rounded-full flex items-center justify-center text-white w-[50%] h-10"
        >
          <Search className="ml-2 h-4 w-4" />
        </button>
        <button
          type="button"
          onClick={handleClear}
          className="ms-2 mt-2 bg-[#0048AE] rounded-full flex items-center justify-center text-white w-[60%] h-10"
        >
          Filter zurücksetzen
        </button>
      </form>
    </div>
  );
};

export default SearchForm;
